const mutations = {
  getCorpSalesTestimonials: (state, corp_sales_testimonial) => {
    state.corp_sales_testimonial = corp_sales_testimonial;
  },
  getCorpSalesTestimonial: (state, corp_sales_testimonial_id) => {
    state.corp_sales_testimonial_id = corp_sales_testimonial_id;
  },
  postCorpSalesTestimonial: (state, new_corp_sales_testimonial) => {
    state.corp_sales_testimonial.push(new_corp_sales_testimonial);
  },
  putCorpSalesTestimonial: (state, payload) => {
    state.corp_sales_testimonial = state.corp_sales_testimonial.map((corp_sales_testimonial) => {
      if (corp_sales_testimonial.corp_sales_testimonial_id === payload.id) {
        return Object.assign({}, corp_sales_testimonial, payload.corp_sales_testimonialData);
      }
      return corp_sales_testimonial;
    });
  },
  delCorpSalesTestimonial(state, id) {
    const index = state.corp_sales_testimonial.findIndex(corp_sales_testimonial => corp_sales_testimonial.corp_sales_testimonial_id == id);
    state.corp_sales_testimonial.splice(index, 1);
  },
};

export default mutations;
